/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_avoid_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`excluded from every generated team`)
};

const es_f1_apex_avoid_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`excluidos de todos los equipos generados`)
};

const de_f1_apex_avoid_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aus jedem generierten Team ausgeschlossen`)
};

const nl_f1_apex_avoid_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`uitgesloten van elk gegenereerd team`)
};

const fr_f1_apex_avoid_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exclus de chaque équipe générée`)
};

const it_f1_apex_avoid_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esclusi da ogni squadra generata`)
};

const pt_br2_f1_apex_avoid_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`excluídos de todos os times gerados`)
};

const pt_f1_apex_avoid_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`excluídos de todas as equipas geradas`)
};

const ja_f1_apex_avoid_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成されるすべてのチームから除外`)
};

const zh_f1_apex_avoid_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从所有生成的阵容中排除`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_avoid_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_avoid_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_avoid_desc", locale)
	if (locale === "en") return en_f1_apex_avoid_desc(inputs)
	if (locale === "es") return es_f1_apex_avoid_desc(inputs)
	if (locale === "de") return de_f1_apex_avoid_desc(inputs)
	if (locale === "nl") return nl_f1_apex_avoid_desc(inputs)
	if (locale === "fr") return fr_f1_apex_avoid_desc(inputs)
	if (locale === "it") return it_f1_apex_avoid_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_avoid_desc(inputs)
	if (locale === "pt") return pt_f1_apex_avoid_desc(inputs)
	if (locale === "ja") return ja_f1_apex_avoid_desc(inputs)
	return zh_f1_apex_avoid_desc(inputs)
};